import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import PricingCards from '../../Components/PricingCards'
import useDocumentTitle from '../../Hooks/PageTitle'

const PricingPage = () => {
  useDocumentTitle("TRoo Web Design Agency | Pricing Cards Page")
  return (
    <Layout>
        <BannerGlobal/>
        <PricingCards/>
    </Layout>
  )
}

export default PricingPage